import { useEffect, useState } from "react";
import tw from "twin.macro";
import Skeleton from "react-loading-skeleton";
import SEO from "components/headers/Seo";
import { Link } from "react-router-dom";
import "./PolicyPages.css";

const Heading = tw.h1`text-center block text-black font-bold text-3xl m-0 py-2 uppercase border-b-2 border-custom-100`;

export default ({ configImages, branch }) => {
  const [banner, setBanner] = useState([]);

  useEffect(() => {
    const getBanner = () => {
      configImages && configImages.E_COMMERCE_BANNERS.forEach((data) => {
        if (data.key === "shippingPolicy") {
          setBanner(data.value);
        }
      });
    };

    getBanner();
    //eslint-disable-next-line
  }, []);

  let Site_Url = "https://vclive.prod-rasiinfotech";

  const list = [
    {
      title: "Shipping Policy",
      description: `We value what you value. And indeed for us Jewels value more than its physical value. ${branch.storeName} always anchors this principle in its value system and takes utmost care in honoring that. Please read carefully about our company's terms and get to know what and how we serve our customers.`,
      show: "show",
    },
    {
      title: "Delivery Schedule",
      description: `${branch.storeName} aims to deliver the shipments in 7 to 21 working days, subject to the availability (Refer 'Product Availability' section) of the products in the showrooms. There may be some delay which may take more than 7 to 21 working days to procure or to design. In such case, the customer will be promptly communicated and made aware of the situation. Delivery guarantee is subject to the terms and conditions of the shipping agent or the courier company. Any inaccuracy in the name or address or inconsistency of the recipient's presence during delivery shall result in non delivery of the product. Estimated duration for delivery indicated in Terms and Conditions commence from the date of dispatch and are for guidance purpose only and may vary invariably. The order will be processed to shipping only after the credit/debit card number given/provided is approved by the bank.`,
      show: "",
    },
    {
      title: "Shipment Procedure",
      description: `The shipment shall be delivered only to the specified delivery address confirmed by the user. Customers have the option of changing the delivery address any number of times before the order is processed for shipment. Once the shipment is processed, neither the specified receiver of the delivery nor the specified address for delivery shall be changed. Any number of products ordered for a single delivery address will be bundled together and shipped as single shipment.\n\nIn case of shipping the 'gifts', the beneficiary must produce their proof of identification recognized as identification proof by the Government of India. Signature of the recipient is considered as acknowledgment and for verification.\n\nThe support team of ${branch.storeName} may contact you to confirm your address, availability etc before shipping the product. The shipment can be tracked by the customer by checking with the courier agent. We are not responsible for any delays caused by courier agencies and/or due to time required for statutory clearances during the delivery process.`,
      show: "",
    },
    {
      title: "Force Majeure",
      description: `Any delay or failure in the delivery hereunder shall be excused and ${branch.storeName} is not responsible if and to the extent caused by the occurrence of a Force Majeure. For purposes of this Agreement, Force Majeure shall mean a cause or event that is not reasonably foreseeable or otherwise caused by or under the control of the Parties (includes ${Site_Url} and courier company) claiming Force Majeure, including miraculous acts of God, natural disasters or emergencies like fires, floods, explosions, riots, wars, hurricane, sabotage terrorism, vandalism, accident, restraint of government, governmental acts or parliamentary restrictions, prohibitions, any enactments on import or export regulation or regulations on exchanges foreign as well as domestic, injunctions, or unavailability to transit, labour strikes, other than those of Seller, the ${branch.storeName} or its Courier agent, that prevent us from delivering the materials and other like events that are beyond the reasonable anticipation and control of the company affected thereby, despite such company's reasonable efforts to prevent, avoid, delay, or mitigate the effect of such acts, events or occurrences, and which events or the effects thereof are not attributable to a failure to deliver its obligations under this Agreement.`,
      show: "",
    },
    {
      title: "Return Shipments",
      description: "If you suspect that the shipment delivered to you to be 'not in good condition' or 'attempted for tampering' or if the package of shipment is tampered, you shall refuse to acknowledge the receipt and return the same before accepting the shipped package.",
      description2: `In case, the authorized recipient is unavailable to receive and acknowledge the package, the courier agent may try to deliver twice after the first delivery as per their policy. If the recipient didn't receive in all the three attempts, the package will be shipped back to the office of ${branch.storeName} and all the cost incurred through the shipment shall be borne by the customer along with the handling charges. The customer shall also bear the shipping charges when shipped again. Refer 'Cancellation Terms' section if in case the customer cancels after the failed delivery.`,
      show: "",
    },
    {
      title: "Packaging",
      description: `${branch.storeName} takes special care in packaging user's precious purchase. The jewels purchased are secured in a shockproof metal box, layered with durable and tamper proof seal from ${branch.storeName}. Every packing is video covered for security reason. If user requests for special gift pack, ${Site_Url} will gift wrap it along with the words you wish your recipient to receive.`,
      show: "",
    },
    {
      title: "Cancellation Terms",
      description: `Users will be informed if their order is aborted or cancelled either partially or fully and the company may request for additional information if required. Cancellation of order shall happen either by the customer or by the company.`,
      show: "",
    },
    {
      title: "Cancellation from Customer",
      description: `To cancel an order you have to send cancellation notice via email only mentioning the Order Id. User can cancel the order for any genuine reason at any time regardless of the shipment status. Customized jewels shall not be entertained for cancellation before or after delivery. We reserve the right to accept or reject requests for order cancellations for any reason`,
      description2: `The user agrees not to dispute the decision made by us and accepts our decision as final, in this regard. As part of usual business practice, if we receive a cancellation notice the full invoice value will be refunded to you to the same bank account through cheque or internet banking from where the payment was originally effected.`,
      show: "",
    },
    {
      title: "Cancellation by Company",
      description: `Situation may arise that ${Site_Url} may not be in a position to accept an order and hence left with no other alternative except cancellation. ${branch.storeName} reserves sole discretionary right to refuse or cancel an order for any reason which the management considers appropriate. Few of the situations that lead to the cancellation of your order includes the unavailability of the product, problems identified by credit and fraudulence investigation of fraud avoidance department, inaccuracies or errors in product or pricing information etc,. If the order is cancelled by the company, after your credit/debit card is charged or if payment is processed through internet banking, the charged /paid amount will be refunded back to the same account.`,
      show: "",
    },
    {
      title: "Fraudulent Transactions",
      description: `${branch.storeName} reserves every right and shall reclaim the product cost, processing charges, shipping cost, legal expenses and other such cost from the user who is involved in a fraudulent transaction.`,
      show: "",
    },
    {
      title: "Disclaimer",
      description: `The information contained in this website is for general information purposes only. Neither ${branch.storeName}, nor its directors, members, employees, agents, any third party, data or content provider shall be liable in any way to you or to any other third party, firm or corporation without limitation whatsoever for any loss, liability, damage (whether direct, indirect, special or consequential), personal injury, risk of harm or expense of any nature whatsoever arising from any delays in operation, inaccuracies, mistakes, errors in, deletion of files or email, defects, viruses, or any failure of performance.`,
      show: "",
    },
    {
      title: "Financial Transaction",
      description: `We as a merchant shall be under no liability whatsoever in respect of any loss or damage arising directly or indirectly out of the decline of authorization for any Transaction, on account of the cardholder having exceeded the preset limit mutually agreed by us with our acquiring bank from time to time.`,
      show: "",
    },
    {
      title: "Liability",
      description: `${branch.storeName} shall not take responsibility or liability for any loss or damage suffered by ordering online or through freight transit for the purchased product, except as required by law, even if it is argued that we could have foreseen the loss or the possibility of it brought to our attention.`,
      show: "",
    },
  ];

  return (
    <>
      <SEO
        title="Shipping Policy - AVM Jewellers"
        description="Shipping Policy of AVM Jewellers."
        name="Company name."
        type="article"
      />
      <div tw="relative font-display overflow-hidden" className="custom_background ej-policy-page">
        {/* Banner */}
        {banner && banner.length > 0 ? (
          <img src={banner} alt="Shipping Policy" className="w-100" style={{ maxHeight: 220, objectFit: "cover" }} />
        ) : (
          <Skeleton tw="w-full" style={{ height: "200px" }} />
        )}

        {/* Page title */}
        <div className="ej-policy-title-wrap">
          <p className="ej-policy-eyebrow">AVM Jewellers</p>
          <Heading>SHIPPING POLICY</Heading>
          {/* Breadcrumb */}
          <div className="ej-policy-breadcrumb">
            <Link to="/" style={{ color: "var(--ink-900)", textDecoration: "none", fontWeight: 600 }}>Home</Link>
            <span>/</span>
            <span className="ej-policy-breadcrumb-current" style={{ color: "var(--ink-700)", fontWeight: 500, textTransform: "capitalize" }}>Shipping Policy</span>
          </div>
        </div>

        {/* Accordion */}
        <div className="container py-2 py-sm-5">
          <div className="accordion ej-policy-accordion" id="accordionShipping">
            {list.map((data, index) => (
              <div className="accordion-item ej-policy-accordion-item" key={index}>
                <h2 className="accordion-header">
                  <button
                    className="accordion-button ej-policy-accordion-btn text-uppercase"
                    type="button"
                    data-bs-toggle="collapse"
                  >
                    {data.title}
                  </button>
                </h2>
                <div
                  id={`shipping${index}`}
                  className="accordion-collapse collapse show ptSans"
                  data-bs-parent="#accordionShipping"
                >
                  <div className="accordion-body ej-policy-accordion-body">
                    <p>{data.description}</p>
                    {data.description2 && <p>{data.description2}</p>}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </>
  );
};